// extracted by mini-css-extract-plugin
export var logo = "mGvCV";
export var logoIcon = "U1nga";
export var logoIconMetaOS = "g8swv";